import React, { FC, useCallback, useEffect } from 'react'
import styles from 'styles/components/template.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { GreyButton, NavButton, OrangeButton } from 'components/Button'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import { State } from 'index'
import { FlexColumn } from 'components/Flex'
import { initCoupons } from 'reducks/coupon/operations'

const CouponCompleteTemplate: FC = () => {
  const query = useSelector((state: State) => state.router.location.query)
  const id = query?.id
  const dispatch = useDispatch()
  const backToCouponPage = useCallback(() => dispatch(push('/admin/coupon')), [dispatch])
  const goToCouponListPage = useCallback(() => dispatch(push(`/admin/coupon/list/${id}`)), [dispatch])
  useEffect(() => {
    dispatch(initCoupons())
  }, [])
  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <FlexColumn alignItems={'center'}>
        <img src={'/icon/done/coupon.svg'} alt={'クーポンの新規登録が完了しました'} />
        <Spacer size={16} />
        <h2 className={`${text.font_xxxlarge} ${text.align_center}`}>
          クーポンの新規登録が
          <br />
          完了しました。
        </h2>
      </FlexColumn>
      <Spacer size={48} />
      <OrangeButton label={'ユーザーへ付与する'} onClick={goToCouponListPage} size={'medium'} type={'main'} />
      <Spacer size={24} />
      <GreyButton label={'クーポン画面へ戻る'} onClick={backToCouponPage} size={'medium'} type={'outlined'} />
      <Spacer size={24} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/admin/shops'} />
      <Spacer size={72} />
    </div>
  )
}

export default CouponCompleteTemplate
